import { LoanCrud } from "./loanCrud";

export default function MyLoan(){
    return <LoanCrud name="我的按揭" type="my" router="myLoan" />
}